const debounce = require("lodash/debounce");

/**
 * @function
 * @description - Check the primary unit radio buttons inside the product tiles, after the slick carousel is initialized
 * @param {Element} $carousel - Carousel element
 */
const initCarouselProductPrimaryUnit = $carousel => {
    if ($carousel.length > 0) {
        $carousel.on("init setPosition", debounce(e => {
            let $productCarousel = $(e.target);

            if ($productCarousel.length > 0) {
                let $primaryRadioButtons = $productCarousel.find(".slick-slide:not(.slick-cloned) .product-measurement-unit[data-type=primary]");

                $primaryRadioButtons.each((index, element) => {
                    $(element).prop("checked", true);
                });
            }
        }, 100));
    }
};

export { initCarouselProductPrimaryUnit };
